import {
    customFields,
    listDataQuestion,
    appUrl,
    form,
    leadInfo,
    leadTextId,
    appointmentChannelId,
    eventId,
    setAppointmentQuestionsCompleted
} from '../../utils/variables';
import { t } from '../../utils/i18n';
import { updateConsultRequestFields, updateQualificationResponses } from '../../services/customFieldService';
import { toastError } from '../../views/components/error';
import { navigateToNextPageWithClearFields } from '../events/navigationHelper';
import { hideAllQuestionsPage } from '../../views/pages/allQuestions';
import { clearCustomFields } from './consultActions';
import { shouldDisqualifyNow } from '../../utils/disqualifierEvaluator';
import { updateLeadStep } from '../../services/leadServices';
import { navigate, setSessionEndStepSentForLeadId, setIsDisqualified } from '../events/movePages';
import { SCREEN } from '../../utils/constants';

export function loadAllQuestions(custom_fields) {
    if (!custom_fields || custom_fields.length === 0) {
        return;
    }

    customFields.splice(0, customFields.length, ...custom_fields);

    const contentContainer = document.querySelector('.allQuestions__content');
    if (!contentContainer) {
        return;
    }

    contentContainer.innerHTML = '';

    custom_fields.forEach((field) => {
        const questionHtml = generateQuestionHtmlByType(field);
        contentContainer.insertAdjacentHTML('beforeend', questionHtml);
        feather.replace();
    });

    initializeAllQuestionListeners(custom_fields);

    const continueBtn = document.querySelector('.allQuestions__container .allQuestionsContinue__btn');
    if (continueBtn) {
        continueBtn.classList.add('disabled');
    }

    validateAllQuestions();
}

function generateQuestionHtmlByType(field) {
    const { id, type, title, required } = field;
    const requiredMark = required ? '<span class="required">*</span>' : '';

    switch (type) {
        case 'height':
            return `
                <div class="heightQuestion__container heightQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="heightboxQuestion__container">
                            <div class="heightQuestion" data-name=''>
                                <input id="height_feet_${id}" type="number" min="3" max="8" class="height_feet" />
                                <h3>${t('feet')}</h3>
                                <input id="height_inch_${id}" type="number" min="0" max="11" class="height_inch" />
                                <h3>${t('inches')}</h3>
                                <span class="heightQuestion__valid hidden">
                                    <i class="ri-check-line"></i>
                                </span>
                                <span class="heightQuestion__invalid hidden">
                                    <i class="ri-close-line"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            `;

        case 'checkbox':
            return `
                <div class="checkboxQuestion__container checkboxQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="content__wrapper">
                            <form name="form-checkbox-${id}">
                <div class="selectCheckboxContainer">
                    <div class="select__boolean">
                        <div class="step__list">
                            <ul class="list-basic"> 
                                <li class="select__radio__row">
                                    <div>
                                        <label class="checkbox-lg-container checkbox-round">
                                                            <input id="checkbox_${id}_yes" type="radio" name="custom_fields_${id}" value="yes">
                                            <span class="checkmark"></span>
                                        </label>
                                        <h3>${t('yes')}</h3>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="select__boolean">
                        <div class="step__list">
                            <ul class="list-basic"> 
                                <li class="select__radio__row">
                                    <div>
                                        <label class="checkbox-lg-container checkbox-round">
                                                            <input id="checkbox_${id}_no" type="radio" name="custom_fields_${id}" value="no">
                                            <span class="checkmark"></span>
                                        </label>
                                        <h3>${t('no')}</h3>
                                    </div>
                                </li>
                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            `;

        case 'textarea':
            return `
                <div class="textareaQuestion__container textareaQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="content__wrapper">
                            <form>
                                <div data-form="textareaQuestion" class="form-control">
                                    <textarea class="textareaQuestion" id="textareaQuestion_${id}" placeholder=""></textarea>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            `;

        case 'text':
            return `
                <div class="textQuestion__container textQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="textboxQuestion__container">
                            <div class="textQuestion" data-name=''>
                                <span class="textQuestion__valid hidden">
                            <i class="ri-check-line"></i>
                        </span>
                                <span class="textQuestion__invalid hidden">
                            <i class="ri-close-line"></i>
                        </span>
                                <input placeholder="" id="textQuestion_${id}" class="textQuestion--input" type="text" autocomplete="off">
                            </div>
                        </div>
                    </div>
                </div>
            `;

        case 'select':
            return `
                <div class="selectQuestion__container selectQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="content__wrapper">
                            <div class="list-question" id="list-question_${id}">
                            </div>
                        </div>
                    </div>
                </div>
            `;

        case 'date':
            return `
                <div class="dateQuestion__container dateQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="dateboxQuestion__container">
                            <div class="dateQuestion">
                                <i data-feather="calendar"></i>
                                <input id="questionDatepicker--dateQuestion__container--${id}" class="dateQuestion--input" type="text" placeholder="" readonly>
                            </div>
                        </div>
                    </div>
                </div>
            `;

        case 'number':
            return `
                <div class="numberQuestion__container numberQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="numberboxQuestion__container">
                    <div class="numberQuestion" data-name=''>
                        <span class="numberQuestion__valid hidden">
                            <i class="ri-check-line"></i>
                        </span>
                        <span class="numberQuestion__invalid hidden">
                            <i class="ri-close-line"></i>
                        </span>
                                <input min="0" placeholder="" id="numberQuestion_${id}" class="numberQuestion--input" type="number" autocomplete="off">
                            </div>
                        </div>
                    </div>
                </div>
            `;

        case 'multi_select':
            return `
                <div class="selectQuestion__container multi_selectQuestion__container--${id} question-item" data-question-id="${id}" data-question-type="${type}">
                    <div class="question-header">
                        <h3 class="question-title">${title} ${requiredMark}</h3>
                    </div>
                    <div class="question-body">
                        <div class="content__wrapper">
                            <div class="list-question" id="list-question_${id}">
                            </div>
                        </div>
                    </div>
                </div>
            `;

        default:
            return `<div class="unsupported-question">${t('unsupported_question_type')} ${type}</div>`;
    }
}

function initializeAllQuestionListeners(custom_fields) {
    custom_fields.forEach((field) => {
        initializeQuestionType(field);
    });

    custom_fields.forEach((field) => {
        if (field.type === 'select' || field.type === 'multi_select') {
            loadSelectOptions(field);
        }
    });

    custom_fields.forEach((field) => {
        if (field.type === 'date') {
            initializeDatePicker(field);
        }
    });

    initializeContinueButtonListener();
}

function initializeQuestionType(field) {
    const { id, type } = field;

    switch (type) {
        case 'text':
            initializeTextQuestion(id);
            break;
        case 'textarea':
            initializeTextareaQuestion(id);
            break;
        case 'number':
            initializeNumberQuestion(id);
            break;
        case 'date':
            break;
        case 'checkbox':
            initializeCheckboxQuestion(id);
            break;
        case 'select':
        case 'multi_select':
            break;
        case 'height':
            initializeHeightQuestion(id);
            break;
    }
}

function initializeTextQuestion(questionId) {
    const input = document.getElementById(`textQuestion_${questionId}`);
    const container = document.querySelector(`.allQuestions__container .textQuestion__container--${questionId}`);
    const textQuestionElement = container?.querySelector('.textQuestion');
    const validIcon = container?.querySelector('.textQuestion__valid');
    const invalidIcon = container?.querySelector('.textQuestion__invalid');

    if (input) {
        input.addEventListener('input', (e) => {
            const value = e.target.value.trim();

            if (value) {
                textQuestionElement?.classList.add('valid');
                textQuestionElement?.classList.remove('invalid');
                validIcon?.classList.remove('hidden');
                invalidIcon?.classList.add('hidden');
                listDataQuestion[questionId] = value;
            } else {
                textQuestionElement?.classList.remove('valid');
                textQuestionElement?.classList.add('invalid');
                validIcon?.classList.add('hidden');
                invalidIcon?.classList.remove('hidden');
                delete listDataQuestion[questionId];
            }

            validateAllQuestions();
        });

        if (listDataQuestion[questionId]) {
            input.value = listDataQuestion[questionId];
            textQuestionElement?.classList.add('valid');
            validIcon?.classList.remove('hidden');
            invalidIcon?.classList.add('hidden');
        }
    }
}

function initializeTextareaQuestion(questionId) {
    const textarea = document.getElementById(`textareaQuestion_${questionId}`);

    if (textarea) {
        textarea.addEventListener('input', (e) => {
            const value = e.target.value.trim();

            if (value) {
                listDataQuestion[questionId] = value;
            } else {
                delete listDataQuestion[questionId];
            }

            validateAllQuestions();
        });

        if (listDataQuestion[questionId]) {
            textarea.value = listDataQuestion[questionId];
        }
    }
}

function initializeNumberQuestion(questionId) {
    const input = document.getElementById(`numberQuestion_${questionId}`);
    const container = document.querySelector(`.allQuestions__container .numberQuestion__container--${questionId}`);
    const numberQuestionElement = container?.querySelector('.numberQuestion');
    const validIcon = container?.querySelector('.numberQuestion__valid');
    const invalidIcon = container?.querySelector('.numberQuestion__invalid');

    if (input) {
        input.addEventListener('input', (e) => {
            const value = e.target.value;

            if (value && !isNaN(value) && value > 0) {
                numberQuestionElement?.classList.add('valid');
                numberQuestionElement?.classList.remove('invalid');
                validIcon?.classList.remove('hidden');
                invalidIcon?.classList.add('hidden');
                listDataQuestion[questionId] = value;
            } else {
                numberQuestionElement?.classList.remove('valid');
                numberQuestionElement?.classList.add('invalid');
                validIcon?.classList.add('hidden');
                invalidIcon?.classList.remove('hidden');
                delete listDataQuestion[questionId];
            }

            validateAllQuestions();
        });

        if (listDataQuestion[questionId]) {
            input.value = listDataQuestion[questionId];
            numberQuestionElement?.classList.add('valid');
            validIcon?.classList.remove('hidden');
            invalidIcon?.classList.add('hidden');
        }
    }
}

function initializeCheckboxQuestion(questionId) {
    const radios = document.querySelectorAll(`.allQuestions__container input[name="custom_fields_${questionId}"]`);

    radios.forEach(radio => {
        radio.addEventListener('change', () => {
            if (radio.checked) {
                listDataQuestion[questionId] = radio.value === 'yes' ? 1 : 0;
                validateAllQuestions();
            }
        });
    });

    if (listDataQuestion[questionId] !== undefined) {
        const savedValue = listDataQuestion[questionId];
        const radioToSelect = savedValue === 1 ?
            document.getElementById(`checkbox_${questionId}_yes`) :
            document.getElementById(`checkbox_${questionId}_no`);
        if (radioToSelect) {
            radioToSelect.checked = true;
        }
    }
}

function initializeHeightQuestion(questionId) {
    const feetInput = document.getElementById(`height_feet_${questionId}`);
    const inchesInput = document.getElementById(`height_inch_${questionId}`);
    const container = document.querySelector(`.allQuestions__container .heightQuestion__container--${questionId}`);
    const heightQuestionElement = container?.querySelector('.heightQuestion');
    const validIcon = container?.querySelector('.heightQuestion__valid');
    const invalidIcon = container?.querySelector('.heightQuestion__invalid');

    const updateHeight = () => {
        const feet = feetInput?.value || '0';
        const inches = inchesInput?.value || '0';

        if (feet && inches) {
            heightQuestionElement?.classList.add('valid');
            heightQuestionElement?.classList.remove('invalid');
            validIcon?.classList.remove('hidden');
            invalidIcon?.classList.add('hidden');
            listDataQuestion[questionId] = `${feet}'${inches}"`;
        } else {
            heightQuestionElement?.classList.remove('valid');
            heightQuestionElement?.classList.add('invalid');
            validIcon?.classList.add('hidden');
            invalidIcon?.classList.remove('hidden');
            delete listDataQuestion[questionId];
        }

        validateAllQuestions();
    };

    if (feetInput) feetInput.addEventListener('input', updateHeight);
    if (inchesInput) inchesInput.addEventListener('input', updateHeight);

    if (listDataQuestion[questionId]) {
        const heightValue = listDataQuestion[questionId];
        const match = heightValue.match(/(\d+)'(\d+)"/);
        if (match) {
            feetInput.value = match[1];
            inchesInput.value = match[2];
            heightQuestionElement?.classList.add('valid');
            validIcon?.classList.remove('hidden');
            invalidIcon?.classList.add('hidden');
        }
    }
}

function loadSelectOptions(field) {
    const { id, type, answers } = field;
    const container = document.getElementById(`list-question_${id}`);

    if (!container || !answers) return;

    const isMultiSelect = type === 'multi_select';

    if (isMultiSelect) {
        let optionsHtml = '';

        answers.forEach(answer => {
            optionsHtml += `
                <div class="option" data-option="${answer}">
                    <span class="option__name">${answer}</span>
                    <span class="option__checkbox" data-option="${answer}">
                        <i class="option__icon-check ri-check-line"></i>
                    </span>
                </div>
            `;
        });

        container.innerHTML = optionsHtml;

        container.querySelectorAll('.option').forEach(option => {
            option.addEventListener('click', () => {
                const value = option.getAttribute('data-option');
                selectOption(value, isMultiSelect, id);
            });
        });

        if (listDataQuestion[id]) {
            try {
                const selectedValues = JSON.parse(listDataQuestion[id]);
                selectedValues.forEach(value => selectOption(value, true, id));
            } catch (e) {
                // Error parsing multi-select values
            }
        }
    } else {
        let selectHtml = '<select class="select-dropdown" id="select-dropdown_' + id + '">';
        selectHtml += `<option value="">${t('select_an_option')}</option>`;

        answers.forEach(answer => {
            selectHtml += '<option value="' + answer + '">' + answer + '</option>';
        });

        selectHtml += '</select>';
        container.innerHTML = selectHtml;

        const selectElement = document.getElementById(`select-dropdown_${id}`);
        if (selectElement) {
            selectElement.addEventListener('change', (e) => {
                const value = e.target.value;
                if (value) {
                    listDataQuestion[id] = value;
                } else {
                    delete listDataQuestion[id];
                }
                validateAllQuestions();
            });

            if (listDataQuestion[id]) {
                selectElement.value = listDataQuestion[id];
            }
        }
    }
}

function selectOption(value, isMultiSelect, questionId) {
    const container = document.getElementById(`list-question_${questionId}`);
    if (!container) return;

    if (isMultiSelect) {
        // Use DOM traversal instead of CSS.escape which can break attribute selectors for values with spaces
        const checkboxes = container.querySelectorAll('.option__checkbox');
        let checkbox = null;
        for (const cb of checkboxes) {
            if (cb.getAttribute('data-option') === value) { checkbox = cb; break; }
        }
        if (checkbox) {
            checkbox.classList.toggle('is-selected');

            const selectedValues = Array.from(container.querySelectorAll('.option__checkbox.is-selected'))
                .map(el => el.getAttribute('data-option'));

            if (selectedValues.length > 0) {
                listDataQuestion[questionId] = JSON.stringify(selectedValues);
            } else {
                delete listDataQuestion[questionId];
            }
        }
    }

    validateAllQuestions();
}

function initializeDatePicker(field) {
    const { id } = field;
    const input = document.getElementById(`questionDatepicker--dateQuestion__container--${id}`);

    if (input && typeof window.flatpickr !== 'undefined') {
        window.flatpickr(input, {
            dateFormat: "Y-m-d",
            onChange: function (selectedDates, dateStr) {
                if (dateStr) {
                    listDataQuestion[id] = dateStr;
                } else {
                    delete listDataQuestion[id];
                }
                validateAllQuestions();
            }
        });

        if (listDataQuestion[id]) {
            input.value = listDataQuestion[id];
        }
    }
}

function initializeContinueButtonListener() {
    const continueBtn = document.querySelector('.allQuestions__container .allQuestionsContinue__btn');
    const backBtn = document.querySelector('.allQuestions__container .allQuestionsBack__btn');

    if (continueBtn) {
        continueBtn.addEventListener('click', async () => {
            if (continueBtn.classList.contains('disabled')) return;

            continueBtn.classList.add('disabled');
            const loadingWrapper = continueBtn.querySelector('.loading__wrapper');
            const loaderIcon = continueBtn.querySelector('.loader__icon');

            if (loadingWrapper) loadingWrapper.classList.remove('hidden');
            if (loaderIcon) {
                loaderIcon.innerHTML = `<img src="${appUrl}/assets/icons/rolling.png" />`;
            }

            try {
                const formId = form?.appointment_channel?.qualification_form?.id;
                if (Object.keys(listDataQuestion).length > 0) {
                    if (typeof formId === 'string' && formId.startsWith('ac-')) {
                        const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                        const fieldLabels = (customFields || []).reduce((acc, f) => {
                            if (f && f.id) acc[f.id] = f.label || f.title || 'Custom field';
                            return acc;
                        }, {});
                        await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels, eventId || undefined);
                    } else {
                        const fieldLabels = (customFields || []).reduce((acc, f) => {
                            if (f && f.id) acc[f.id] = f.label || f.title || 'Custom field';
                            return acc;
                        }, {});
                        await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                    }
                }

                const fields = customFields?.length ? customFields : (form?.appointment_channel?.qualification_form?.custom_fields ?? []);
                const minDisqualifiers = form?.appointment_channel?.min_disqualifier_matches ?? 1;
                if (appointmentChannelId && fields.length > 0 && shouldDisqualifyNow(fields, listDataQuestion, minDisqualifiers) && leadInfo?.id) {
                    await updateLeadStep(leadInfo.id, 'disqualified', 'true');
                    setSessionEndStepSentForLeadId(leadInfo.id);
                    hideAllQuestionsPage();
                    clearAllQuestions();
                    clearCustomFields();
                    setIsDisqualified(true);
                    navigate(SCREEN.THE_END);
                    if (loadingWrapper) loadingWrapper.classList.add('hidden');
                    if (loaderIcon) loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
                    continueBtn.classList.remove('disabled');
                    return;
                }

                if (appointmentChannelId) {
                    setAppointmentQuestionsCompleted(true);
                }
                await navigateToNextPageWithClearFields();
                hideAllQuestionsPage();
                clearAllQuestions();
                clearCustomFields();

            } catch (error) {
                toastError(error.response?.data?.message);

                continueBtn.classList.remove('disabled');
                if (loadingWrapper) loadingWrapper.classList.add('hidden');
                if (loaderIcon) {
                    loaderIcon.innerHTML = '<i class="ri-arrow-right-line"></i>';
                }
            }
        });
    }

    if (backBtn) {
        backBtn.addEventListener('click', () => {
            clearAllQuestions();
        });
    }
}


/**
 */
function validateAllQuestions() {
    const continueBtn = document.querySelector('.allQuestions__container .allQuestionsContinue__btn');
    if (!continueBtn) return;

    const requiredQuestions = customFields.filter(field => field.required);
    const allRequiredAnswered = requiredQuestions.every(field => {
        const answer = listDataQuestion[field.id];

        if (answer === undefined || answer === null) return false;

        if (typeof answer === 'string') {
            if (answer.startsWith('[') && answer.endsWith(']')) {
                try {
                    const parsed = JSON.parse(answer);
                    return Array.isArray(parsed) && parsed.length > 0;
                } catch {
                    return false;
                }
            }
            return answer.trim() !== '';
        }

        if (typeof answer === 'number') {
            return true;
        }

        return Boolean(answer);
    });
    if ((allRequiredAnswered && requiredQuestions.length > 0) || requiredQuestions.length === 0) {
        continueBtn.classList.remove('disabled');
    } else {
        continueBtn.classList.add('disabled');
    }
}

export function getAllQuestionAnswers() {
    return { ...listDataQuestion };
}

export function clearAllQuestions() {
    const contentContainer = document.querySelector('.allQuestions__content');
    if (contentContainer) {
        contentContainer.innerHTML = '';
    }

    Object.keys(listDataQuestion).forEach(key => {
        delete listDataQuestion[key];
    });

    customFields.splice(0, customFields.length);
}
